import { render, staticRenderFns } from "./TipsFree.vue?vue&type=template&id=33e02695&scoped=true&"
import script from "./TipsFree.vue?vue&type=script&lang=js&"
export * from "./TipsFree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e02695",
  null
  
)

export default component.exports